import { times } from 'lodash';
import { nanoid } from 'nanoid';

// Gets word's template
// @key: string | word's unique identifier
export const getWord = (key) => {
	return {
		key,
		value: ''
	};
};

// Gets option's template
export const getOption = () => {
	return {
		key: nanoid(),
		content: '',
		correct: false
	};
};

// Gets question's template
// @type: string | task's type
// @options: number | task's option count
export const getQuestion = (type, options) => {
	switch (type) {
	case 'quiz':
		return {
			key: nanoid(),
			content: '',
			options: times(options, () => getOption())
		};
	case 'essay':
	case 'multiple':
	case 'upload':
		return {
			key: nanoid(),
			content: ''
		};
	case 'spellcheck':
		return {
			key: nanoid(),
			content: '',
			words: []
		};
	case 'connect':
		return {
			key: nanoid(),
			content: '',
			answer: ''
		};
	default:
		console.log('Undefined task type! - ', type);
	}
};

// Gets task's template
// @param type task's type
// @param questions generator's question count
// @param options generator's option count
export const getTask = (type = 'quiz', questions = 1, options = 1) => {
	return times(questions, () => getQuestion(type, options));
};